import ContextButton from "./ContextButton.vue";
import { pluginify } from "./../../util";
export default pluginify(ContextButton);
export { ContextButton };
